<template>
  <dx-modal :value="show" title="Recibo do repasse" size="sm"
            :closable="!printing" @input="close()" id="modal-transfer-receipt">
    <div class="stenci-group stenci-alert tr-help">
      <p>
        <strong>{{ professional ? professional.name : '' }}</strong>
        <template v-if="council"> · {{ council }}</template>
      </p>
    </div>

    <div class="form-group">
      <label class="form-label">Modelo</label>
      <div class="btn-group btn-group-block">
        <button class="btn" :class="type === 'short' ? 'btn-secondary' : 'btn-gray'"
                @click="type = 'short'">Resumido</button>
        <button class="btn" :class="type === 'detailed' ? 'btn-secondary' : 'btn-gray'"
                @click="type = 'detailed'">Detalhado</button>
      </div>
    </div>

    <div class="form-group tr-receipt-scope" v-if="!single">
      <label class="form-label">O que imprimir</label>
      <label class="form-radio">
        <input type="radio" value="consolidated" v-model="scope"
               :disabled="financials.length === 0">
        <i class="form-icon"></i>
        Contas a pagar consolidadas no período
        <small>
          {{ financials.length }} {{ financials.length === 1 ? 'recibo' : 'recibos' }}
          <template v-if="financials.length === 0">
            — nada consolidado para este profissional
          </template>
        </small>
      </label>
      <label class="form-radio">
        <input type="radio" value="preview" v-model="scope" :disabled="!hasPending">
        <i class="form-icon"></i>
        Tudo que aparece na tela, incluindo pendentes
        <small>
          Prévia de conferência, sem valor de recibo
          <template v-if="hasPending"> · {{ pendingLabel }}</template>
          <template v-else> — nenhum item pendente</template>
        </small>
      </label>
    </div>

    <ul class="tr-receipt-list" v-if="scope === 'consolidated' && financials.length > 0">
      <li v-for="item in financials" :key="String(item.bundleId)">
        <span>{{ item.label }}</span>
        <span class="tr-num">{{ item.total | currency }}</span>
      </li>
    </ul>

    <template slot="footer">
      <button class="btn btn-primary btn-icon btn-icon-left mr-1"
              :class="{loading: printing}" :disabled="printing || !canPrint" @click="print">
        <fa-icon :icon="['fal', 'print']"/>Imprimir
      </button>
      <button class="btn" :disabled="printing" @click="close()">Sair</button>
    </template>
  </dx-modal>
</template>

<script>
import { councilLabel } from '../helpers';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    professional: {
      type: Object,
      default: null,
    },
    financials: {
      type: Array,
      default: () => [],
    },
    pending: {
      type: Object,
      default: () => ({
        cashRegisterItemIds: [], medicalReportIds: [], count: 0, total: 0,
      }),
    },
    single: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      printing: false,
      type: 'short',
      scope: this.financials.length > 0 ? 'consolidated' : 'preview',
    };
  },
  computed: {
    council() {
      return councilLabel(this.professional);
    },
    hasPending() {
      return this.pending && this.pending.count > 0;
    },
    pendingLabel() {
      const { count } = this.pending;
      return `${count} ${count === 1 ? 'item pendente' : 'itens pendentes'}`;
    },
    canPrint() {
      if (this.scope === 'consolidated') return this.financials.length > 0;
      return this.hasPending || this.financials.length > 0;
    },
  },
  methods: {
    async print() {
      if (!this.canPrint) return;
      this.printing = true;
      try {
        if (this.scope === 'consolidated') {
          await this.financials.reduce((chain, item) => chain.then(() => (
            this.$file.print(`/billing-transfers/${item.bundleId}/print`, { type: this.type })
          )), Promise.resolve());
        } else {
          await this.$file.print('/billing-transfers/preview-print', {
            professionalId: String(this.professional.id),
            cashRegisterItemIds: this.pending.cashRegisterItemIds,
            medicalReportIds: this.pending.medicalReportIds,
            bundleIds: this.financials.map(item => String(item.bundleId)),
            type: this.type,
          }, { method: 'POST' });
        }
      } finally {
        this.printing = false;
      }
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>
